import bookaMeetingApi from "./request";

/** Push subscription shape from subscription.toJSON() - store this on the backend */
export type PushSubscriptionPayload = {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  expirationTime?: number | null;
  phone_number_id?: string;
};

/**
 * Save the push subscription to the backend so it can send push notifications later.
 * Backend should store { endpoint, keys, phone_number_id } per user/device.
 *
 * Important: The subscription is tied to the origin (e.g. https://app.example.com or
 * http://localhost:3000) where it was created. Push will only be delivered when the
 * user's app is on that same origin. Backend must send to a subscription that was
 * created on the same origin the user is using.
 */
export async function savePushSubscription(
  subscription: PushSubscriptionPayload,
  phone_number_id?: string
): Promise<void> {
  const data: PushSubscriptionPayload = {
    ...subscription,
    ...(phone_number_id ? { phone_number_id } : {}),
  };
  await bookaMeetingApi.requestWIthAuth({
    url: "/push-subscription",
    method: "POST",
    data,
  });
}
